import { Link } from "react-router-dom";
import { Leaf, Phone, Mail, MapPin, ShieldCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#1A362D] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#C47B57] text-white">
                <Leaf className="h-5 w-5" />
              </span>
              <span className="font-heading text-xl font-semibold">Master Touch</span>
            </div>
            <p className="text-sm text-[#B7C2B6] leading-relaxed">
              Professional cleaning & landscaping crafted with care. Transforming homes and outdoor spaces across Calgary, Airdrie & Okotoks.
            </p>
            <div className="flex items-center gap-2 mt-5 text-[#8FA38C]">
              <ShieldCheck className="h-4 w-4" />
              <span className="text-xs uppercase tracking-widest">Licensed · Bonded · Insured</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg mb-4 text-white">Services</h4>
            <ul className="space-y-2.5 text-sm text-[#B7C2B6]">
              <li><Link to="/services" className="hover:text-[#C47B57] transition-colors">Residential Cleaning</Link></li>
              <li><Link to="/services" className="hover:text-[#C47B57] transition-colors">Commercial Cleaning</Link></li>
              <li><Link to="/services" className="hover:text-[#C47B57] transition-colors">Lawn Care</Link></li>
              <li><Link to="/services" className="hover:text-[#C47B57] transition-colors">Garden Design</Link></li>
              <li><Link to="/visualizer" className="hover:text-[#C47B57] transition-colors">AI Visualizer</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg mb-4 text-white">Company</h4>
            <ul className="space-y-2.5 text-sm text-[#B7C2B6]">
              <li><Link to="/about" className="hover:text-[#C47B57] transition-colors">About Us</Link></li>
              <li><Link to="/booking" className="hover:text-[#C47B57] transition-colors">Book a Service</Link></li>
              <li><Link to="/contact" className="hover:text-[#C47B57] transition-colors">Contact</Link></li>
              <li><Link to="/faq" className="hover:text-[#C47B57] transition-colors">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg mb-4 text-white">Get in Touch</h4>
            <ul className="space-y-3 text-sm text-[#B7C2B6]">
              <li className="flex items-center gap-2.5"><Phone className="h-4 w-4 text-[#8FA38C]" /> 403-690-0222</li>
              <li className="flex items-center gap-2.5"><Mail className="h-4 w-4 text-[#8FA38C]" /> itsjaspreet4u@gmail.com</li>
              <li className="flex items-start gap-2.5"><MapPin className="h-4 w-4 text-[#8FA38C] mt-0.5" /> Serving Calgary, Airdrie & Okotoks, AB</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#8FA38C]">© {new Date().getFullYear()} Master Touch Cleaning & Landscaping Inc. All rights reserved.</p>
          <p className="text-xs text-[#8FA38C]">Mon–Sat · 7:00 AM – 7:00 PM</p>
        </div>
      </div>
    </footer>
  );
}
